<div
    *ngIf="regData?.testSession"
    class="page"
>
    <app-step-progress [steps]="steps"></app-step-progress>
    <div>
        <h4>Select {{childTermName$ | async }} accounts</h4>
        <br />
        <app-proof-of-identity-selection-summary
            [testSession]="regData.testSession"
            [isBusinessAccount]="true"
        ></app-proof-of-identity-selection-summary>
        <div
            *ngIf="childAccounts?.length > 0; else noChildAccount"
            class="row"
        >
            <div class="col-md-12">
                <h5 class="py-2">Select {{childTermName$ | async | lowercase}} accounts to include in the test registration:</h5>
                <div class="col-md-12 search-box text-center my-4 py-2">
                    <label class="control-label col-md-2">Filter by Name </label>
                    <input
                        class="col-md-4 p-1"
                        [(ngModel)]="searchText"
                        placeholder="Enter name"
                        (ngModelChange)="searchTextChanged()"
                    />
                    <label class="col-md-6">{{selectedChildsArray.length}} {{childTermName$ | async | lowercase}} account(s) selected</label>
                </div>
                <div class="py-4">
                    <table class="table">
                        <thead>
                            <tr>
                                <th class="text-center align-middle">
                                    <button
                                        type="button"
                                        class="btn btn-sm toggle-btn"
                                        (click)="toggleSelectAll()"
                                        *ngIf="selectAll || selectedChildsArray.length == 0"
                                    >Select All</button>
                                    <button
                                        type="button"
                                        class="btn btn-sm toggle-btn"
                                        (click)="toggleSelectAll()"
                                        *ngIf="!selectAll && selectedChildsArray.length > 0"
                                    >Deselect All</button>
                                </th>
                                <th class="text-center align-middle">{{childTermName$ | async }} Account</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="let childAccount of filteredChildAccounts"
                                [ngClass]="{selected: childAccount.selected === true, registered: (childAccount.regId && childAccount.regId > 0) }"
                            >
                                <td class="text-center align-middle">
                                    <span *ngIf="childAccount.registering"><i class="fa fa-spinner fa-spin"></i></span>
                                    <input
                                        *ngIf="childAccount.canRegister === true && !childAccount.registering === true"
                                        type="checkbox"
                                        (change)="onSelect($event)"
                                        [value]="childAccount.userAccountId"
                                        [disabled]="!childAccount.canRegister"
                                        [checked]="childAccount.selected"
                                    />
                                    <small>
                                        <span *ngIf="!childAccount.personalInformationCompleted"><i
                                                class="fa fa-exclamation-triangle fa-lg"
                                                style="color: #d07300"
                                            ></i> Incomplete personal information</span>
                                        <span *ngIf="childAccount.regId && !childAccount.canRemoveFromCart"><i
                                                class="fa fa-check-circle fa-lg"
                                                style="color: #009b14"
                                            ></i> Registered</span>
                                        <span *ngIf="childAccount.regId && childAccount.canRemoveFromCart">
                                            <i
                                                class="fa fa-check-circle fa-lg"
                                                style="color: #009b14"
                                            ></i> Added to cart
                                            <button
                                                type="button"
                                                class="btn btn-default btn-sm"
                                                style="margin-left: 10px;"
                                                (click)="removeFromCart(childAccount)"
                                            >Remove</button>
                                        </span>
                                    </small>
                                </td>
                                <td>
                                    <div>
                                        {{childAccount.fullName}} - {{childAccount.email}}
                                        <br />
                                        <small>
                                            <a
                                                [routerLink]="['/account/edit-child-personal-info']"
                                                [queryParams]="{userAccountId: childAccount.userAccountId, userAccountEmail: childAccount.email, redirectToReg: 1}"
                                            >View or edit personal information</a>.
                                        </small>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="pull-right">
                        <button
                            type="button"
                            class="btn btn-primary"
                            (click)="batchAddChildRegs()"
                            [disabled]="selectedChildsArray.length <= 0"
                        >Add {{selectedChildsArray.length}} selected {{childTermName$ | async | lowercase}} account(s) to shopping cart</button>
                    </div>
                </div>
            </div>
        </div>
        <ng-template #noChildAccount>
            <div class="alert alert-danger d-inline-block">
                <p>No {{childTermName$ | async | lowercase}} account available. Click <a routerLink="/account/create-child-account">here</a> to create a new client account</p>
            </div>
        </ng-template>
    </div>
</div>

<app-modal
    #successAddModal
    title="Registration done"
    body="{{this.successfulRegCount}} account(s) added to shopping cart. View shopping cart?"
    isConfirm="true"
    (clickPositive)="redirectToShoppingCart()"
>
</app-modal>

<app-modal
    #confirmRemoveModal
    title="Confirmation"
    body="Remove from shopping cart?"
    isConfirm="true"
    (clickPositive)="confirmRemove()"
>
</app-modal>
